import BaseAPI from '@/apis/base/baseApi';

export default class INApi extends BaseAPI {
  apiName = 'IN';
}
